export const getLocalStorage = () => {
  const generic = JSON.parse(localStorage.getItem("generic"));
  return generic ? generic : {};
};

export const getLocalStorageItem = (key) => getLocalStorage()[key];
